import React from 'react';
import { Icon } from '@teetsh/app/src/components/Icons/icon';
import styled from '@emotion/styled';
import tw from 'twin.macro';

interface Props {
  children?: React.ReactNode;
  icon?: Icon;
}

const StyledIcon = styled.div`
  ${tw`h-5 w-5 text-neutral-moderate`}
`;

export default function Line(props: Props) {
  const { children } = props;
  return (
    <>
      <div tw="col-span-1">
        <StyledIcon as={props.icon as any} />
      </div>
      <div tw="col-span-11">{children}</div>
    </>
  );
}
